// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Pthn","footer":"ChangeClinic_footer__3JL0d"};